const MAIN_FRAMES = {
  QUERY_MANAGER: 'Query Manager',
  QUERY_MANAGER_HISTORY: 'Query Manager History',

  PA_ALERT_HISTORY: 'PA - Alert History',
  PA_DB_INFO: 'PA - DB Info',
  PA_EXCEPTION_SUMMARY: 'PA - Exception Summary',
  PA_PARAMETER_HISTORY: 'PA - Parameter History',
  PA_OBJECT_SIZE: 'PA - Object Size',
  PA_PLAN_ANALYSIS: 'PA - Plan Analysis',
  PA_SEARCH_SESSION: 'PA - Search Session',
  PA_SEARCH_SQL: 'PA - Search SQL',
  PA_SQL_SUMMARY: 'PA - SQL Summary',
  PA_TOP_N_ANALYSIS: 'PA - Top N Analysis',
  PA_TABLESPACE: 'PA - Tablespace',
  PA_TRANSACTION_TREND: 'PA - Transaction Trend',
  PA_TREND_ANALYSIS: 'PA - Trend Analysis',
  PA_UNDO_TEMP: 'PA - Undo & Temp',
  PA_WAIT_SUMMARY: 'PA - Wait Summary',
  PA_TOP_TRANSACTION_SUMMARY: 'PA - Top Transaction Summary',
  PA_TOP_SQL_SUMMARY: 'PA - Top SQL Summary',
  PA_PERFORMANCE_HEATMAP: 'PA - Performance Heatmap',
  PA_THREAD_DUMP: 'PA - Thread Dump',
  PA_GC_LOG_ANALYSIS: 'PA - GC Log Analysis',
  PA_KUBERNETES: 'PA - Kubernetes',
  PA_REPLICATION: 'PA - Replication Analysis',

  PA_ADDITIONAL: 'PA - Additional Information',
} as const;

export const PA_FRAME_NAMES = {
  QUERY_MANAGER: {
    TABLE_REFERENCE: `${MAIN_FRAMES.QUERY_MANAGER}/Table Reference`,
    CREATOR_INFO: `${MAIN_FRAMES.QUERY_MANAGER}/Creator Info`,
    MODIFIER_INFO: `${MAIN_FRAMES.QUERY_MANAGER}/Modifier Info`,
    RUN_QUERY: `${MAIN_FRAMES.QUERY_MANAGER}/Run Query`,
    VIEW_PLAN: `${MAIN_FRAMES.QUERY_MANAGER}/View Plan`,
    FOLDER: `${MAIN_FRAMES.QUERY_MANAGER}/get Folder`,
    QUERY_ID: `${MAIN_FRAMES.QUERY_MANAGER}/get Query Id`,
  },
  QUERY_MANAGER_HISTORY: {
    HISTORY_LIST: `${MAIN_FRAMES.QUERY_MANAGER_HISTORY}/History List`,
    HISTORY_DETAIL: `${MAIN_FRAMES.QUERY_MANAGER_HISTORY}/History Detail`,
  },
  PA_KUBERNETES: {
    KUBERNETES_EVENT: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Event`,
    EVENT_RESOURCE: `${MAIN_FRAMES.PA_KUBERNETES}/Event Resource`,
    EVENT_INFORMATION: `${MAIN_FRAMES.PA_KUBERNETES}/Event Information`,
    EVENT_HISTORY: `${MAIN_FRAMES.PA_KUBERNETES}/Event History`,
    EVENT_LOG: `${MAIN_FRAMES.PA_KUBERNETES}/Event Log`,
    EVENT_METRIC: `${MAIN_FRAMES.PA_KUBERNETES}/Event Metric`,
    EVENT_METRIC_LIMIT_REQUEST: `${MAIN_FRAMES.PA_KUBERNETES}/Event Metric Limit Request`,
    KUBERNETES_EVENT_TARGET_FILTER: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Event Target Filter`,
    KUBERNETES_EVENT_TARGET_FILTER_OPTIONS: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Event Target Filter Options`,
    KUBERNETES_EVENT_HEATMAP: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Event Heatmap`,
    KUBERNETES_EVENT_METRIC: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Event Metric`,
    KUBERNETES_EVENT_PIE: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Event Pie`,
    KUBERNETES_EVENT_LIST: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Event List`,
    KUBERNETES_EVENT_LIST_FILTER: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Event List Filter`,
    KUBERNETES_EVENT_ALERT: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Event Alert`,
    KUBERNETES_EVENT_REASON_LIST: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Event Reason List`,
    KUBERNETES_EVENT_REASON_LIST_DELETE: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Event Reason List Delete`,
    KUBERNETES_EVENT_REASON_LIST_SAVE: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Event Reason List Save`,
    KUBERNETES_EVENT_REASON_LIST_UPDATE: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Event Reason List Update`,
    KUBERNETES_HISTORY_MANAGEMENT_TARGET_FILTER: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes History Management Target Filter`,
    KUBERNETES_HISTORY_MANAGEMENT_TARGET_FILTER_OPTIONS: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes History Management Target Filter Options`,
    KUBERNETES_HISTORY_MANAGEMENT_OBJECT_FILTERS: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes History Management Object Filters`,
    KUBERNETES_HISTORY_MANAGEMENT_HEATMAP: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes History Management Heatmap`,
    KUBERNETES_HISTORY_MANAGEMENT_STATUS_HEATMAP: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes History Management Status Heatmap`,
    KUBERNETES_HISTORY_MANAGEMENT_STATUS_METRICS: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes History Management Status Metrics`,
    KUBERNETES_HISTORY_MANAGEMENT_EVENT_TIMELINE: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes History Management Event Timeline`,
    KUBERNETES_HISTORY_MANAGEMENT_STATUS_TIMELINE: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes History Management Status Timeline`,
    KUBERNETES_JOB_SUMMARY_TARGET_FILTER: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Job Summary Target Filter`,
    KUBERNETES_JOB_SUMMARY_HEATMAP: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Job Summary Heatmap`,
    KUBERNETES_JOB_SUMMARY_HISTORY: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes Job Summary History`,
    TREND_ANALYSIS_TARGET_LIST: `${MAIN_FRAMES.PA_KUBERNETES}/Trend Analysis - Target List`,
    TREND_ANALYSIS_CHART: `${MAIN_FRAMES.PA_KUBERNETES}/Trend Analysis - Chart`,
    TREND_ANALYSIS_CHART_METRICS: `${MAIN_FRAMES.PA_KUBERNETES}/Trend Analysis - Chart Metrics`,
    TREND_ANALYSIS_SNAPSHOT_TIMES: `${MAIN_FRAMES.PA_KUBERNETES}/Trend Analysis - Snapshot Times`,
    TREND_ANALYSIS_SNAPSHOT_PODS: `${MAIN_FRAMES.PA_KUBERNETES}/Trend Analysis - Snapshot Pods`,
    TREND_ANALYSIS_SNAPSHOT_PROCESS: `${MAIN_FRAMES.PA_KUBERNETES}/Trend Analysis - Snapshot Process`,
    TREND_ANALYSIS_EVENT: `${MAIN_FRAMES.PA_KUBERNETES}/Trend Analysis - Event`,
    TREND_ANALYSIS_ROLLOUT: `${MAIN_FRAMES.PA_KUBERNETES}/Trend Analysis - Rollout`,
    TREND_ANALYSIS_SNAPSHOT_PVC: `${MAIN_FRAMES.PA_KUBERNETES}/Trend Analysis - Snapshot PVC`,
    TREND_ANALYSIS_SCHEDULING: `${MAIN_FRAMES.PA_KUBERNETES}/Trend Analysis - Scheduling`,
    TREND_ANALYSIS_LOAD_BALANCING: `${MAIN_FRAMES.PA_KUBERNETES}/Trend Analysis - Load Balancing`,
    TREND_ANALYSIS_LOG: `${MAIN_FRAMES.PA_KUBERNETES}/Trend Analysis - Log`,
    TREND_ANALYSIS_LOG_CONFIG_STATUS: `${MAIN_FRAMES.PA_KUBERNETES}/Trend Analysis - Log Config Status`,
    KUBERNETES_HISTORY_MANAGEMENT_LOG: `${MAIN_FRAMES.PA_KUBERNETES}/Kubernetes History Management Log`,
    RESOURCE_EXCEPTION_PIE: `${MAIN_FRAMES.PA_KUBERNETES}/Resource Exception Pie`,
    RESOURCE_EXCEPTION_METRIC: `${MAIN_FRAMES.PA_KUBERNETES}/Resource Exception Metric`,
    RESOURCE_EXCEPTION_LIST: `${MAIN_FRAMES.PA_KUBERNETES}/Resource Exception List`,
    RESOURCE_EXCEPTION_WORKLOAD_HISTORY: `${MAIN_FRAMES.PA_KUBERNETES}/Resource Exception Workload History`,
  },

  PA_DB_INFO: {
    DATABASE_SIZE_INFO: `${MAIN_FRAMES.PA_DB_INFO}/Database Size Info`,
    DATABASE_FILE_INFO: `${MAIN_FRAMES.PA_DB_INFO}/Database File Info`,
    DATABASE_INFO: `${MAIN_FRAMES.PA_DB_INFO}/DATABASE Info`,
    FILE_TREND_DAY: `${MAIN_FRAMES.PA_DB_INFO}/File Trend - Day`,
    FILE_TREND_TIME: `${MAIN_FRAMES.PA_DB_INFO}/File Trend - Time`,
    TOP_TABLE: `${MAIN_FRAMES.PA_DB_INFO}/Top Table`,
  },
  PA_EXCEPTION_SUMMARY: {
    TOTAL_COUNT_CHART: `${MAIN_FRAMES.PA_EXCEPTION_SUMMARY}/Total Exception/Transaction Count - Chart`,
    TOTAL_COUNT_LIST: `${MAIN_FRAMES.PA_EXCEPTION_SUMMARY}/Total Exception/Transaction Count - List`,
    RATIO: `${MAIN_FRAMES.PA_EXCEPTION_SUMMARY}/ Exception/Transaction Ratio`,
    EXCEPTION_LIST: `${MAIN_FRAMES.PA_EXCEPTION_SUMMARY}/Exception List`,
  },
  PA_SQL_SUMMARY: {
    STAT_RATIO: `${MAIN_FRAMES.PA_SQL_SUMMARY}/Stat Ratio - Summary`,
    TOP_SQL: `${MAIN_FRAMES.PA_SQL_SUMMARY}/Top SQL`,
  },
  PA_TOP_N_ANALYSIS: {
    ORDER_BY: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Search - Order By`,
    VALUE: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Value - Trend`,
    VALUE_TOP: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Value - Top`,
    TOP_SQL: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Top SQL`,
    TOP_SCHEMA: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Top Schema`,
    TOP_USER: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Top User`,
    TOP_DATABASE: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Top Database`,
    TOP_MODULE: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Top Module`,
    TOP_PROCEDURE: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Top Procedure`,
    TOP_NODE: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Top Node`,
    TREND_TOTAL_SQL: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Trend - Total SQL`,
    TREND_SQL: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Trend - SQL`,
    TREND_SCHEMA: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Trend - Schema`,
    TREND_MODULE: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Trend - Module`,
    TREND_USER: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Trend - User`,
    TREND_DATABASE: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Trend - Database`,
    TREND_TOTAL_PROCEDURE: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Trend - Total Procedure`,
    TREND_PROCEDURE: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Trend - Procedure`,
    TREND_NODE: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Trend - Node`,
    SQL: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/SQL`,
    FULL_TEXT: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Full Text`,
  },
  PA_PLAN_ANALYSIS: {
    PLAN_ANALYSIS_LIST: `${MAIN_FRAMES.PA_PLAN_ANALYSIS}/Plan Analysis List`,
    TREND: `${MAIN_FRAMES.PA_PLAN_ANALYSIS}/Trend`,
    SQL_LIST: `${MAIN_FRAMES.PA_PLAN_ANALYSIS}/SQL List`,
    PLAN: `${MAIN_FRAMES.PA_PLAN_ANALYSIS}/Plan`,
    PLAN_HASH_LIST: `${MAIN_FRAMES.PA_PLAN_ANALYSIS}/Plan Hash List`,
    REASON: `${MAIN_FRAMES.PA_PLAN_ANALYSIS}/Reason`,
    DOWNLOAD: `${MAIN_FRAMES.PA_PLAN_ANALYSIS}/[Download] Plan XML`,
  },
  PA_SEARCH_SQL: {
    ORDER_BY_FIELDS: `${MAIN_FRAMES.PA_SEARCH_SQL}/Order By Fields`,
    SEARCH_SQL_LIST: `${MAIN_FRAMES.PA_SEARCH_SQL}/Search SQL List`,
    TREND: `${MAIN_FRAMES.PA_SEARCH_SQL}/Trend`,
    FULL_TEXT: `${MAIN_FRAMES.PA_SEARCH_SQL}/Full Text`,
    HISTORY: `${MAIN_FRAMES.PA_SEARCH_SQL}/History`,
    PLAN: `${MAIN_FRAMES.PA_SEARCH_SQL}/Plan`,
  },
  PA_SEARCH_SESSION: {
    SEARCH_SESSION_LIST: `${MAIN_FRAMES.PA_SEARCH_SESSION}/Search Session List`,
  },
  PA_TABLESPACE: {
    ASM_DAY: `${MAIN_FRAMES.PA_TABLESPACE}/ASM - Day`,
    TAS_DAY: `${MAIN_FRAMES.PA_TABLESPACE}/TAS - Day`,
    ASM_DAY_PARTIAL: `${MAIN_FRAMES.PA_TABLESPACE}/ASM - Day,Partial`,
    TAS_DAY_PARTIAL: `${MAIN_FRAMES.PA_TABLESPACE}/TAS - Day,Partial`,
    ASM_TIME: `${MAIN_FRAMES.PA_TABLESPACE}/ASM - Time`,
    TAS_TIME: `${MAIN_FRAMES.PA_TABLESPACE}/TAS - Time`,
    ASM_TIME_PARTIAL: `${MAIN_FRAMES.PA_TABLESPACE}/ASM - Time,Partial`,
    TAS_TIME_PARTIAL: `${MAIN_FRAMES.PA_TABLESPACE}/TAS - Time,Partial`,
    ASM_GROUP: `${MAIN_FRAMES.PA_TABLESPACE}/ASM - Group`,
    TAS_GROUP: `${MAIN_FRAMES.PA_TABLESPACE}/TAS - Group`,
    ASM_SIZE_FORECAST: `${MAIN_FRAMES.PA_TABLESPACE}/ASM - Size Forecast`,
    TAS_SIZE_FORECAST: `${MAIN_FRAMES.PA_TABLESPACE}/TAS - Size Forecast`,
    TABLESPACE_DAY: `${MAIN_FRAMES.PA_TABLESPACE}/Tablespace - Day`,
    TABLESPACE_DAY_PARTIAL: `${MAIN_FRAMES.PA_TABLESPACE}/Tablespace - Day,Partial`,
    TABLESPACE_TIME: `${MAIN_FRAMES.PA_TABLESPACE}/Tablespace - Time`,
    TABLESPACE_TIME_PARTIAL: `${MAIN_FRAMES.PA_TABLESPACE}/Tablespace - TIme,Partial`,
    TOP_100_TABLESPACE: `${MAIN_FRAMES.PA_TABLESPACE}/Top 100 Tablespace`,
    TOP_100_SEGMENT: `${MAIN_FRAMES.PA_TABLESPACE}/Top 100 Segment`,
  },
  PA_TRANSACTION_TREND: {
    RESPONSE_TIME_CHART: `${MAIN_FRAMES.PA_TRANSACTION_TREND}/Response Time Chart`,
    TRANSACTION_SUMMARY: `${MAIN_FRAMES.PA_TRANSACTION_TREND}/Transaction Summary`,
    TRANSACTION_LIST: `${MAIN_FRAMES.PA_TRANSACTION_TREND}/Transaction List`,
    TRANSACTION_LIST_COUNT: `${MAIN_FRAMES.PA_TRANSACTION_TREND}/Transaction List - Count`,
    SEARCH_FILTER: `${MAIN_FRAMES.PA_TRANSACTION_TREND}/Search Filter`,
  },
  PA_WAIT_SUMMARY: {
    WAIT_CLASS: `${MAIN_FRAMES.PA_WAIT_SUMMARY}/Wait Class`,
    WAIT_CLASS_EVENT: `${MAIN_FRAMES.PA_WAIT_SUMMARY}/Wait Class & Event`,
    WAIT_SQL_LIST: `${MAIN_FRAMES.PA_WAIT_SUMMARY}/Wait SQL List`,
  },
  PA_UNDO_TEMP: {
    UNDO_USED_SIZE: `${MAIN_FRAMES.PA_UNDO_TEMP}/Undo > Used Size`,
    UNDO_AVG_USED_SIZE: `${MAIN_FRAMES.PA_UNDO_TEMP}/Undo > Avg Used Size`,
    UNDO_SESSION_LIST: `${MAIN_FRAMES.PA_UNDO_TEMP}/Undo > Session List`,
    TEMP_USED_SIZE: `${MAIN_FRAMES.PA_UNDO_TEMP}/Temp > Used Size`,
    TEMP_AVG_USED_SIZE: `${MAIN_FRAMES.PA_UNDO_TEMP}/Temp > Avg Used Size`,
    TEMP_SESSION_LIST: `${MAIN_FRAMES.PA_UNDO_TEMP}/Temp > Session List`,
  },
  PA_TREND_ANALYSIS: {
    ACTIVE_TRANSACTION: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Active Transaction`,
    ACTIVE_SESSION_SECONDS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Active Session Sec Times`,
    ACTIVE_SESSION: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Active Session`,
    ACTIVE_SESSION_TOTAL: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Active Session (Total)`,
    APPLICATION_RATIO: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Application Ratio`,
    ALERT: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Alert`,
    BACKENDS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Backends`,
    BACKENDS_SECONDS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Backends Sec Times`,
    BLOCKED: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Blocked`,
    BLOCKED_DETAIL: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Blocked Detail`,
    DB_METRIC: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/DB Metric`,
    CHECK_POOL_ACTIVE: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Check Pool Active`,
    LOCK_TREE: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Lock Tree`,
    LOCK_TREE_SECONDS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Lock Tree Sec Times`,
    META_LOCK_TREE: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Meta Lock Tree`,
    META_LOCK_TREE_SECONDS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Meta Lock Tree Sec Times`,
    LONG_ACTIVE_BACKENDS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Long Active Backends`,
    LONG_ACTIVE_THREAD: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Long Active Thread`,
    SESSION: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Session`,
    SESSION_SECONDS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Session Sec Times`,
    SQL_SUMMARY: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/SQL Summary`,
    LONG_SESSION_QUERY: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Long Session Query`,
    LONG_ACTIVE_SESSION: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Long Active Session`,
    TOP_PROCESSES: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Top Processes`,
    SQL_STAT: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/SQL Stat`,
    SQL_STAT_SECONDS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/SQL Stat Sec Times`,
    TREND: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Trend `,
    TREND_POOL: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Trend Pool`,
    METRIC_LIST: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Metric List `,
    THREADS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Threads`,
    THREADS_SECONDS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Threads Sec Times`,
    PROCESS_LIST: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Process List`,
    TOP_EVENT: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Top Event`,
    SCAN_RATIO: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Scan Ratio`,
    TOP_OBJECT: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Top Object`,
    TOP_SQL: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Top SQL`,
    TIME_MODEL: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Time Model`,
    TIME_RANGE_BAR: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Time Range Bar`,
    WAIT_LIST: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Wait > List`,
    WAIT_CHART: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Wait > Chart`,
    WAIT_CHAINS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Wait Chains`,
    WAIT_CHAINS_SECONDS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Wait Chains Seconds`,
    WAIT_CLASS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Wait Class`,
    WAIT_EVENT: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Wait Event`,
    USER_RATIO: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/User Ratio`,
    USER_CONNECTION_INFO: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/User Connection Info`,
    USER_LOG: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/User Log`,
    FULL_TEXT: `${MAIN_FRAMES.PA_TOP_N_ANALYSIS}/Full Text`,
    SLOW_QUERY: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Slow Query`,
    VACUUM: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Vacuum`,
    VACUUM_SECONDS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Vacuum Sec Times`,
    PROCESS: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Process`,
    LONG_RUNNING_QUERY: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Long Running Query`,
    PART_LOG: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Part Log`,
    MERGE: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Merge`,
    MUTATION: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Mutation`,
    ACTIVE_QUERY: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Active Query`,
    EVENT_HISTORY: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Event History`,
    ACTIVE_TRANSACTION_CHART: `${MAIN_FRAMES.PA_TREND_ANALYSIS}/Active Transaction Chart`,
  },
  PA_ALERT_HISTORY: {
    ALERT_CHART: `${MAIN_FRAMES.PA_ALERT_HISTORY}/Alert - Chart`,
    ALERT_LIST: `${MAIN_FRAMES.PA_ALERT_HISTORY}/Alert - List`,
    TOP_ALERT: `${MAIN_FRAMES.PA_ALERT_HISTORY}/Top Alert`,
  },
  PA_PARAMETER_HISTORY: {
    PARAMETER_LIST: `${MAIN_FRAMES.PA_PARAMETER_HISTORY}/Parameter List`,
  },
  PA_OBJECT_SIZE: {
    DATABASE_OBJECT_SIZE_CHART: `${MAIN_FRAMES.PA_OBJECT_SIZE}/Database/Object Size Trend`,
    DATABASE_SIZE_INFO: `${MAIN_FRAMES.PA_OBJECT_SIZE}/Object Size Info`,
    TOP_OBJECT: `${MAIN_FRAMES.PA_OBJECT_SIZE}/Top 30 Object`,
  },
  PA_TOP_TRANSACTION_SUMMARY: {
    TOP_LIST: `${MAIN_FRAMES.PA_TOP_TRANSACTION_SUMMARY}/Top List`,
    TXN_TREND_SUMMARY: `${MAIN_FRAMES.PA_TOP_TRANSACTION_SUMMARY}/Transaction Trend Summary`,
    TIMED_TXN_SUMMARY: `${MAIN_FRAMES.PA_TOP_TRANSACTION_SUMMARY}/Timed Transaction Summary`,
    SQL: `${MAIN_FRAMES.PA_TOP_TRANSACTION_SUMMARY}/SQL`,
    REMOTE: `${MAIN_FRAMES.PA_TOP_TRANSACTION_SUMMARY}/Remote`,
  },
  PA_TOP_SQL_SUMMARY: {
    TOP_LIST: `${MAIN_FRAMES.PA_TOP_SQL_SUMMARY}/Top List`,
    TXN_TREND_SUMMARY: `${MAIN_FRAMES.PA_TOP_SQL_SUMMARY}/Transaction Trend Summary`,
    TIMED_TREND_SUMMARY: `${MAIN_FRAMES.PA_TOP_SQL_SUMMARY}/Timed Trend Summary`,
    TRANSACTION: `${MAIN_FRAMES.PA_TOP_SQL_SUMMARY}/Transaction`,
  },
  PA_PERFORMANCE_HEATMAP: {
    HEATMAP: `${MAIN_FRAMES.PA_PERFORMANCE_HEATMAP}/Heatmap`,
    METRIC: `${MAIN_FRAMES.PA_PERFORMANCE_HEATMAP}/Metric`,
  },
  PA_REPLICATION: {
    TOP_GAP: `${MAIN_FRAMES.PA_REPLICATION}/Top Replication Objects`,
    GAP_STATUS: `${MAIN_FRAMES.PA_REPLICATION}/Gap Status`,
    SESSION: `${MAIN_FRAMES.PA_REPLICATION}/Session`,
    GAP_TREND: `${MAIN_FRAMES.PA_REPLICATION}/Replication Gap Trend`,
    SESSION_TREND: `${MAIN_FRAMES.PA_REPLICATION}/Active Session Trend`,
  },
  PA_THREAD_DUMP: {
    WAS_LIST: `${MAIN_FRAMES.PA_THREAD_DUMP}/WAS List`,
    THREAD_DUMP_LIST: `${MAIN_FRAMES.PA_THREAD_DUMP}/Thread Dump List`,
    THREAD_DUMP_DETAIL: `${MAIN_FRAMES.PA_THREAD_DUMP}/Thread Dump Detail`,
    THREAD_DUMP_FULL_TEXT: `${MAIN_FRAMES.PA_THREAD_DUMP}/Thread Dump Full Text`,
    THREAD_DUMP_DETAIL_BY_THREAD_ID: `${MAIN_FRAMES.PA_THREAD_DUMP}/Thread Dump Detail By Thread Id`,
    THREAD_DUMP_ANALYZER: `${MAIN_FRAMES.PA_THREAD_DUMP}/Thread Dump Analyzer`,
  },
  PA_GC_LOG_ANALYSIS: {
    WAS_LIST: `${MAIN_FRAMES.PA_GC_LOG_ANALYSIS}/WAS List`,
    FILES: `${MAIN_FRAMES.PA_GC_LOG_ANALYSIS}/Files`,
    ANALYZE: `${MAIN_FRAMES.PA_GC_LOG_ANALYSIS}/Analyze`,
  },
  PA_ADDITIONAL: {
    PG_DATABASE_LIST: `${MAIN_FRAMES.PA_ADDITIONAL}/Postgresql Database List`,
  },
} as const;
